"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reduxPersist = require("redux-persist");

var _storage = _interopRequireDefault(require("redux-persist/lib/storage"));

var _initialState = _interopRequireDefault(require("./initialState"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function exportHTML(_ref) {
  var content = _ref.content;
  return "" + "<div id=\"emthemesModezBannersBlockAdvTopHeader\" class=\"banners emthemesModezBannersBlockAdvTopHeader\">\n" + "<div class=\"banner\">".concat(content, "</div>\n") + "</div>";
}

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'UPDATE_STATE':
      return _objectSpread(_objectSpread({}, state), action.payload);

    case 'EXPORT_CODE':
      return _objectSpread(_objectSpread({}, state), {}, {
        exportedHTML: exportHTML(state)
      });

    case 'RESET_STATE':
      return (0, _initialState["default"])();

    default:
      return state;
  }
};

var ormPersistConfig = {
  key: 'TopBannerBuilderComponent',
  storage: _storage["default"]
};

var _default = (0, _redux.combineReducers)({
  TopBannerBuilderComponent: (0, _reduxPersist.persistReducer)(ormPersistConfig, reducer)
});

exports["default"] = _default;